import React, { useState, useEffect, useContext } from 'react';
import { FiHome, FiUsers, FiFileText, FiMoreHorizontal, FiEdit2, FiSearch, FiEdit, FiCalendar } from 'react-icons/fi';
import { IoLogInOutline  } from 'react-icons/io5';
import { IoChevronForwardSharp } from "react-icons/io5";

import axios from "axios"

import { NavLink } from 'react-router-dom';
import { TokenContext } from "../components/tokenChecker";
import { GiHamburgerMenu } from "react-icons/gi";

import MyInformation from '../components/myInfomation';
import { fetchUserData } from '../api/getUserData'; // 위에서 작성한 함수



import '../css/Navbar.css';
import '../css/wa.css';

const Navbar = () => {
  const { isTokenInvalid } = useContext(TokenContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoImage, setLogoImage] = useState("");
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  const [userData, setUserData] = useState(null); // 사용자 데이터 상태
  const [notLogined, setNotLogined] = useState(false); // 로그인되지 않은 상태

  const [search, setSearch] = useState(''); // Ensure search is a string, not boolean

  useEffect(() => {
    const token = localStorage.getItem('token');
    setIsLoggedIn(!!token);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const token = localStorage.getItem('token');
      setIsLoggedIn(!!token);
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);




  useEffect(() => {

    const getLogo = async () => {
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/logo`, {});
            setLogoImage(data.logo);
            console.log("네비게이션 바");
            console.log(data);
        } catch (err) {
            // 실패 시 사용자 데이터를 설정하지 않음
        } finally {
        }
    };

    getLogo();
}, []); // 컴포넌트가 처음 렌더링될 때 실행


  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter' && search.trim() !== '') {
      window.location.href = '/search/' + search.trim(); // Redirect to search page with query
    }
  };

  return (
    <>
      <div className={`mobile-menu ${isMobileMenuOpen ? 'opened' : ''}`}>
        <div className='mobile-menu-close' onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}></div>
        <div className='mobile-menu-main'>
            <div className='mobile-close' onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
              <IoChevronForwardSharp />
            </div>
            <MyInformation/>
            
            <NavLink to="/community/editor/new" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiEdit2 className="icon" />
                글쓰기
              </div>
            </NavLink>
            <NavLink to="/" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiHome className="icon" />
                홈
              </div>
            </NavLink>
            <NavLink to="/community" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiUsers className="icon" />
                커뮤니티
              </div>
            </NavLink>
            <NavLink to="/news" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiFileText className="icon" />
                뉴스
              </div>
            </NavLink>
            <NavLink to="/monthly" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiFileText className="icon" />
                월간지
              </div>
            </NavLink>
            <NavLink to="/event" className={({ isActive }) => (isActive ? 'selected mobile-item' : 'mobile-item')}>
              <div className='mobile-item-bar'></div>
              <div className='mobile-item-main'>
                <FiCalendar className="icon" />
                소식
              </div>
            </NavLink>

        </div>
      </div>
      <div className={`top-bar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="top-bar-container">
          <div className="logo">
            <img src={logoImage}></img>
          </div>

          <div className={`menu-items`}>
            <NavLink to="/" className={({ isActive }) => (isActive ? 'selected menu-item' : 'menu-item')}>
              <FiHome className="icon" />
              홈
            </NavLink>
            <NavLink to="/community" className={({ isActive }) => (isActive ? 'selected menu-item' : 'menu-item')}>
              <FiUsers className="icon" />
              커뮤니티
            </NavLink>
            <NavLink to="/news" className={({ isActive }) => (isActive ? 'selected menu-item' : 'menu-item')}>
              <FiFileText className="icon" />
              뉴스
            </NavLink>
            <NavLink to="/monthly" className={({ isActive }) => (isActive ? 'selected menu-item' : 'menu-item')}>
              <FiFileText className="icon" />
              월간지
            </NavLink>
            <NavLink to="/event" className={({ isActive }) => (isActive ? 'selected menu-item' : 'menu-item')}>
              <FiCalendar className="icon" />
              소식
            </NavLink>

          
          </div>

          <div className="user-actions">
            <div className="search-box">
              <FiSearch className="icon" />
              <input
                type="text"
                placeholder="검색어를 입력하세요"
                onFocus={() => setIsSearchActive(true)}
                onBlur={() => setIsSearchActive(false)}
                onKeyDown={handleSearchKeyDown} // Handle Enter key press
                value={search}
                onChange={(e) => setSearch(e.target.value)} // Update search value on change
              />
            </div>

            {isTokenInvalid ? (
              <a href="/login">
                <button className="write-button">
                  <IoLogInOutline className="icon" />
                  로그인
                </button>
              </a>
            ) : (
              <a href="/community/editor/new">
                <button className="write-button">
                  <FiEdit className="icon" />
                  글쓰기
                </button>
              </a>
            )}
          </div>

          <button
            className="mobile-menu-button"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <GiHamburgerMenu className="mb-icon" />
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
